import { Controller } from "@hotwired/stimulus";
import * as bootstrap from "bootstrap";

export default class extends Controller {
  static targets = ["tooltip"];
  static collapseCookieName = "sidebarCollapsePreference";
  static mobileBreakpoint = 768; // Bootstrap md breakpoint

  connect() {
    this.handleResponsiveBehavior();
    this.initializeTooltips();
    this.addResizeListener();
  }

  disconnect() {
    this.removeResizeListener();
  }

  toggle() {
    this.element.classList.toggle("collapsed");
    this.updateTooltips();
    this.storeCollapseState();
  }

  initializeTooltips() {
    const isCollapsed = this.element.classList.contains("collapsed");
    this.tooltipInstances = this.tooltipTargets.map((el) => {
      const tooltip = new bootstrap.Tooltip(el);
      if (!isCollapsed) {
        tooltip.disable();
      }
      return tooltip;
    });
  }

  updateTooltips() {
    const isCollapsed = this.element.classList.contains("collapsed");

    this.tooltipInstances.forEach((tooltip) => {
      if (isCollapsed) {
        tooltip.enable();
      } else {
        tooltip.disable();
      }
    });
  }

  storeCollapseState() {
    const isCollapsed = this.element.classList.contains("collapsed");
    document.cookie = `${this.constructor.collapseCookieName}=${isCollapsed}; path=/; expires=Thu, 31 Dec 2099 23:59:59 GMT;`;
  }

  restoreCollapseState() {
    const storedState = this.getStoredCollapseState();
    if (storedState === "true") {
      this.element.classList.add("collapsed");
    } else if (storedState === "false") {
      this.element.classList.remove("collapsed");
    }
  }

  getStoredCollapseState() {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === this.constructor.collapseCookieName) {
        return value;
      }
    }
    return "false";
  }

  handleResponsiveBehavior() {
    if (this.isMobileDevice() || this.isSmallScreen()) {
      // Force collapse on mobile/small screens
      this.element.classList.add("collapsed");
      this.updateTooltips();
    } else {
      // Restore user preference on larger screens
      this.restoreCollapseState();
    }
  }

  isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  isSmallScreen() {
    return window.innerWidth < this.constructor.mobileBreakpoint;
  }

  addResizeListener() {
    this.resizeHandler = this.handleResize.bind(this);
    window.addEventListener('resize', this.resizeHandler);
  }

  removeResizeListener() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }

  handleResize() {
    // Use debouncing to avoid excessive calls
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      if (this.isSmallScreen()) {
        // Auto-collapse on small screens
        if (!this.element.classList.contains("collapsed")) {
          this.element.classList.add("collapsed");
          this.updateTooltips();
        }
      } else {
        // On larger screens, restore user preference if currently auto-collapsed
        if (this.element.classList.contains("collapsed") && this.getStoredCollapseState() === "false") {
          this.element.classList.remove("collapsed");
          this.updateTooltips();
        }
      }
    }, 250); // 250ms debounce
  }
}
